import { getRMSession } from 'selectors';
import { getTimestamp } from './get-timestamp';
import { parseCookies } from './parse-cookies';

export const buildTrackingParams = (
  trackingEntitiesIds: Record<string, unknown>,
  options: {
    orchestratorHost: string;
    apiKey?: string;
  },
  cookies: string,
) => {
  const parsedCookies = parseCookies(cookies);
  const sessionValue = getRMSession(parsedCookies);

  const data = {
    ...trackingEntitiesIds,
    link: { name: 'session', value: sessionValue },
    timestamp: getTimestamp(),
  };

  const config = {
    orchestratorHost: options?.orchestratorHost,
    apiKey: options?.apiKey,
  };

  return { data, config };
};
